import { watchEffect } from "vue";
import { can } from "../composables/useCan";

/**
 * Directive v-can — tampilkan / sembunyikan (atau disable) elemen berdasarkan
 * hak akses user sekarang. Reaktif: ikut berubah kalau user diganti via setUser.
 *
 * Contoh pemakaian (nanti dipasang sendiri di template):
 *   <q-btn v-can="'WAREHOUSE'" />                  // butuh role/akses WAREHOUSE
 *   <q-btn v-can="['ADMIN','WAREHOUSE']" />        // any-of (OR)
 *   <q-btn v-can.all="['A','B']" />                // butuh keduanya (AND)
 *   <q-btn v-can.disable="'GATEKEEPER'" />         // di-disable, bukan disembunyikan
 *   <q-btn v-can:not="'GATEKEEPER'" />             // sembunyikan kalau PUNYA hak itu
 */

const PREV_DISPLAY = "__vCanPrevDisplay";
const STOP = "__vCanStop";

function evaluate(el, binding) {
  let allowed = can(binding.value, { all: !!binding.modifiers.all });
  // argumen :not membalik hasil pengecekan
  if (binding.arg === "not") allowed = !allowed;

  if (binding.modifiers.disable) {
    // mode disable: elemen tetap tampil tapi dimatikan
    if ("disabled" in el) el.disabled = !allowed;
    el.classList.toggle("l-can-disabled", !allowed);
    el.style.pointerEvents = allowed ? "" : "none";
    el.style.opacity = allowed ? "" : "0.5";
    return;
  }

  // mode default: sembunyikan dengan display:none (bisa dikembalikan)
  if (allowed) {
    if (el[PREV_DISPLAY] !== undefined) {
      el.style.display = el[PREV_DISPLAY];
      delete el[PREV_DISPLAY];
    }
  } else {
    if (el[PREV_DISPLAY] === undefined) el[PREV_DISPLAY] = el.style.display;
    el.style.display = "none";
  }
}

export default {
  mounted(el, binding) {
    // watchEffect supaya ikut reaktif saat state user berubah (setUser)
    el[STOP] = watchEffect(() => evaluate(el, binding));
  },
  updated(el, binding) {
    evaluate(el, binding);
  },
  unmounted(el) {
    if (el[STOP]) {
      el[STOP]();
      delete el[STOP];
    }
  },
};
